// src/protocols/print.js — печат помощници (копия; app.js пази свои за легаси).

export function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

export function printHTML(html){
  var frame=document.createElement('iframe');
  frame.setAttribute('aria-hidden','true');
  frame.style.cssText='position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden';
  document.body.appendChild(frame);
  var done=false;
  function go(){ if(done) return; done=true; try{ frame.contentWindow.focus(); frame.contentWindow.print(); }catch(e){} setTimeout(function(){ try{ frame.remove(); }catch(e){} }, 2000); }
  frame.onload=function(){ setTimeout(go, 200); };
  frame.srcdoc=html;
  setTimeout(go, 1500); // предпазна мрежа, ако onload не се задейства
}
